(function () {
  if (window.__cmproGa4) return;
  window.__cmproGa4 = true;

  const contextEl = document.getElementById('ga4-page-context');
  if (!contextEl || typeof window.gtag !== 'function') return;
  let ctx;
  try {
    ctx = JSON.parse(contextEl.textContent);
  } catch (error) {
    return;
  }

  const sent = new Set();
  const REP_TRIGGER_SELECTOR =
    '.mp-hide-price-call-button-link, .mp-hide-price-call-button, [data-sales-rep-trigger], #contact-rep-trigger';
  const ALEX_SUFFIXES = ['alexander-schroeder-land', 'pest-identification', 'intelligent-pest-mgmt'];

  function send(name, params) {
    window.gtag('event', name, params || {});
  }

  function sendOnce(key, name, params) {
    if (sent.has(key)) return;
    sent.add(key);
    send(name, params);
  }

  function plLogoApplied() {
    try {
      return localStorage.getItem('plc:logo:v1') ? 'true' : 'false';
    } catch (error) {
      return 'false';
    }
  }

  function handleFromHref(href) {
    const match = /\/products\/([^/?#]+)/.exec(href || '');
    return match ? decodeURIComponent(match[1]) : '';
  }

  // Strips a Shopify success param so a refresh does not report the same submit twice.
  function stripParam(name) {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }

  /* Product views */

  if (ctx.item) {
    sendOnce('view_item', 'view_item', {
      items: [ctx.item],
      private_label: ctx.private_label ? 'true' : 'false',
      pl_logo_applied: plLogoApplied(),
    });
  }

  /* Product lists */

  const LIST_LINK_SELECTOR =
    'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], a.private-label-customizer__photo';
  const CLICK_LINK_SELECTOR =
    LIST_LINK_SELECTOR + ', a[id^="CardMediaLink-"], .private-label-customizer__card-copy a[href*="/products/"]';
  const lists = new Map();

  function listFor(section) {
    const id = (section.id || '').replace(/^shopify-section-(template--\d+__)?/, '') || 'list';
    let name;
    if (section.querySelector('#product-grid')) {
      name = ctx.page_type === 'search' ? 'Search results' : ctx.collection_title || id;
    } else if (section.querySelector('.private-label-customizer__grid')) {
      name = 'Private label visualizer';
    } else {
      const heading = section.querySelector('h2');
      name = heading ? heading.textContent.trim().slice(0, 100) : id;
    }
    return { item_list_id: id, item_list_name: name };
  }

  function cardName(link) {
    const card = link.closest('.card-wrapper, .private-label-customizer__card');
    const title = card && card.querySelector('.card__heading, h3, h2');
    return ((title && title.textContent) || link.textContent || '').trim().slice(0, 100);
  }

  function reportLists() {
    const sections = new Map();
    document.querySelectorAll(LIST_LINK_SELECTOR).forEach((link) => {
      const section = link.closest('.shopify-section');
      const handle = handleFromHref(link.getAttribute('href'));
      if (!section || !handle || lists.has(section)) return;
      if (!sections.has(section)) sections.set(section, []);
      const items = sections.get(section);
      if (items.some((item) => item.item_id === handle)) return;
      items.push({ item_id: handle, item_name: cardName(link), index: items.length, quantity: 1 });
    });

    sections.forEach((items, section) => {
      const list = listFor(section);
      lists.set(section, { list, items });
      send('view_item_list', {
        item_list_id: list.item_list_id,
        item_list_name: list.item_list_name,
        result_count: items.length,
        items: items.slice(0, 24).map((item) => Object.assign({}, item, list)),
      });
    });
  }

  reportLists();
  // Recommendations render after load; facet re-renders reuse an already-reported section.
  let listTimer;
  new MutationObserver(() => {
    clearTimeout(listTimer);
    listTimer = setTimeout(reportLists, 500);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest(CLICK_LINK_SELECTOR);
      if (!link) return;
      const section = link.closest('.shopify-section');
      const entry = section && lists.get(section);
      const handle = handleFromHref(link.getAttribute('href'));
      if (!entry || !handle) return;
      const item = entry.items.find((candidate) => candidate.item_id === handle);
      if (!item) return;
      send('select_item', {
        item_list_id: entry.list.item_list_id,
        item_list_name: entry.list.item_list_name,
        items: [Object.assign({}, item, entry.list)],
      });
    },
    true
  );

  /* Sales rep modal */

  const modal = document.querySelector('[data-sales-rep-quick-add]');
  let repContext = null;

  function ctaLocation(trigger) {
    if (!trigger) return 'unknown';
    if (trigger.closest('.mp-hide-price-call-button-link, .mp-hide-price-call-button')) return 'hide_price_button';
    if (trigger.id === 'contact-rep-trigger') return 'pdp_icon_row';
    if (trigger.matches('[data-private-label-detail-rep]')) return 'pl_detail';
    if (trigger.classList.contains('private-label-customizer__btn')) return 'pl_footer_cta';
    if (trigger.classList.contains('private-label-customizer__rep')) return 'pl_card';
    if (trigger.classList.contains('quick-add__submit')) return 'collection_card';
    if (trigger.closest('cart-notification, #cart-notification')) return 'cart_notification';
    if (trigger.classList.contains('cart__checkout-button')) return 'cart_page';
    if (trigger.closest('.product-form__buttons')) return 'pdp_buy_button';
    return 'unknown';
  }

  function triggerProductHandle(trigger) {
    const card = trigger && trigger.closest('.card-wrapper, .private-label-customizer__card');
    const link = card && card.querySelector('a[href*="/products/"]');
    return (link && handleFromHref(link.getAttribute('href'))) || ctx.product_handle || '';
  }

  function repMode() {
    const selectWrap = modal.querySelector('.sales-rep-quick-add__select-wrap');
    return selectWrap && selectWrap.hidden ? 'direct' : 'state_select';
  }

  if (modal) {
    new MutationObserver(() => {
      if (modal.hidden) {
        repContext = null;
        return;
      }
      if (repContext) return;
      const trigger = Array.from(document.querySelectorAll(REP_TRIGGER_SELECTOR)).find(
        (element) => element.getAttribute('aria-expanded') === 'true'
      );
      repContext = {
        trigger,
        cta_location: ctaLocation(trigger),
        product_handle: triggerProductHandle(trigger),
      };
      // The direct-rep layout is applied in a promise callback after the modal opens.
      setTimeout(() => {
        if (!repContext) return;
        send('rep_modal_open', {
          cta_location: repContext.cta_location,
          product_handle: repContext.product_handle,
          rep_mode: repMode(),
          pl_logo_applied: plLogoApplied(),
        });
      }, 0);
    }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });

    // Bubbles to the document after the theme's own listener on the select has rendered the reps.
    document.addEventListener('change', (event) => {
      if (event.target.id !== 'SalesRepQuickAddState' || !event.target.value || !repContext) return;
      send('rep_state_select', {
        rep_state: event.target.value,
        rep_count: modal.querySelectorAll('.sales-rep-quick-add__rep-group').length,
        cta_location: repContext.cta_location,
        product_handle: repContext.product_handle,
      });
    });
  }

  /* Phone and email clicks. Capture phase: the private-label email path cancels the default action. */

  function pageCtaLocation(link) {
    if (ctx.template_suffix === 'sales-representatives') return 'sales_reps_page';
    if (ALEX_SUFFIXES.indexOf(ctx.template_suffix) !== -1) return 'alex_page';
    if (link.closest('footer, .footer')) return 'footer';
    return 'other';
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('a[href^="tel:"], a[href^="mailto:"]');
      if (!link) return;
      // SP Hide Price renders some rep buttons as tel: links; sales-rep-quick-add.js opens the modal instead.
      const trigger = event.target.closest(REP_TRIGGER_SELECTOR);
      if (trigger && (trigger.matches('[data-sales-rep-trigger], #contact-rep-trigger') || trigger.closest('#ProductGridContainer'))) return;
      const method = link.getAttribute('href').indexOf('tel:') === 0 ? 'phone' : 'email';
      const params = { contact_method: method, pl_logo_applied: plLogoApplied() };

      if (modal && repContext && link.closest('[data-sales-rep-list]')) {
        const toInbox = method === 'email' && repContext.trigger && repContext.trigger.hasAttribute('data-rep-email-to');
        const stateSelect = modal.querySelector('#SalesRepQuickAddState');
        Object.assign(params, {
          contact_target: toInbox ? 'inbox' : 'rep',
          cta_location: repContext.cta_location,
          product_handle: repContext.product_handle,
          rep_mode: repMode(),
          rep_state: (stateSelect && stateSelect.value) || '',
        });
      } else {
        Object.assign(params, {
          contact_target: 'page_link',
          cta_location: pageCtaLocation(link),
          product_handle: ctx.product_handle || '',
        });
      }
      send('contact_click', params);
    },
    true
  );

  /* Form success: Shopify redirects back with a param and renders the success message. */

  const params = new URLSearchParams(window.location.search);

  if (params.get('contact_posted') === 'true' && document.querySelector('#ContactForm .form-status:not([role="alert"])')) {
    sendOnce('generate_lead', 'generate_lead', {
      lead_type: 'contact_form',
      form_id: 'ContactForm',
      form_location: ctx.template_suffix || ctx.page_type,
    });
    stripParam('contact_posted');
  }

  const newsletterSuccess = document.querySelector('.newsletter-form__message--success');
  if (params.get('customer_posted') === 'true' && newsletterSuccess) {
    sendOnce('sign_up', 'sign_up', {
      method: 'newsletter',
      form_location: window.location.hash.slice(1) || newsletterSuccess.id || 'newsletter',
    });
    stripParam('customer_posted');
  }

  /* PestWorld giveaway entry, dispatched by private-label-customizer.js after Klaviyo accepts it */

  document.addEventListener('private-label:giveaway-entered', (event) => {
    const detail = event.detail || {};
    sendOnce('generate_lead:pl_giveaway', 'generate_lead', {
      lead_type: 'pl_giveaway',
      form_location: 'private_label_giveaway',
      pl_interest: detail.interest || '',
      entry_source: detail.entry_source || 'direct',
    });
  });

  /* Blocked buy attempts, dispatched by b2b-cart-lockdown.js */

  const lastBlocked = {};
  document.addEventListener('b2b:cart-blocked', (event) => {
    const type = (event.detail && event.detail.type) || 'unknown';
    const now = Date.now();
    if (lastBlocked[type] && now - lastBlocked[type] < 5000) return;
    lastBlocked[type] = now;
    send('cart_blocked', {
      block_type: type,
      product_handle: ctx.product_handle || '',
      page_type: ctx.page_type,
    });
  });

  /* Private label logo preview, read from the customizer's status line */

  const plStatus = document.querySelector('[data-private-label-status]');
  if (plStatus) {
    new MutationObserver(() => {
      const text = plStatus.textContent;
      let source = '';
      if (/restored/i.test(text)) source = 'restored';
      else if (/^Sample logo shown/.test(text.trim())) source = 'sample';
      else if (/shown as a preview only|is previewing now/.test(text)) source = 'upload';
      if (source) sendOnce('pl_logo_applied:' + source, 'pl_logo_applied', { logo_source: source });
    }).observe(plStatus, { childList: true, characterData: true, subtree: true });
  }

  /* 404 */

  if (ctx.page_type === '404') {
    sendOnce('page_not_found', 'page_not_found');
  }
})();
